// Utility for RTL (Right-to-Left) language support

export const isRTLLanguage = (languageIndex: number): boolean => {
  // Hebrew is at index 4
  return languageIndex === 4;
};

export const getTextDirection = (languageIndex: number): 'ltr' | 'rtl' => {
  return isRTLLanguage(languageIndex) ? 'rtl' : 'ltr';
};

export const applyRTL = (languageIndex: number) => {
  const direction = getTextDirection(languageIndex);
  document.documentElement.dir = direction;
  document.documentElement.lang = getLanguageCode(languageIndex);
};

export const getLanguageCode = (languageIndex: number): string => {
  const codes = ['en', 'ru', 'uk', 'ka', 'he'];
  return codes[languageIndex] || 'en';
};
